<form class="grid grid-cols-4 gap-4" [formGroup]="form" autocomplete="off">
  <!-- DATE -->
  <oiq-form-date class="col-span-1" formControlName="date" label="Date"></oiq-form-date>

  <!-- TIME -->
  <oiq-form-time class="col-span-1" formControlName="time" label="Time"></oiq-form-time>

  <!-- REMINDER 1 -->
  <oiq-form-dropdown
    class="col-span-1"
    formControlName="interval"
    label="Remind me"
    [searchable]="false"
    [options]="form.reminderIntervals"
    [configuration]="{ id: 'value', text: 'name' }"></oiq-form-dropdown>

  <!-- REMINDER 2 -->
  <oiq-form-dropdown
    class="col-span-1"
    formControlName="interval2"
    label="2nd reminder"
    [searchable]="false"
    [options]="form.reminderIntervals2"
    [configuration]="{ id: 'value', text: 'name' }"></oiq-form-dropdown>

  @if (!(form.isCollectionDetail$ | async)) {
    <div class="col-span-4 grid grid-cols-4 gap-4">
      <oiq-form-dropdown
        formControlName="entityType"
        label="Entity"
        [searchable]="false"
        [options]="form.entityTypes"
        [configuration]="{ id: 'value', text: 'name' }"></oiq-form-dropdown>

      <div class="col-span-3">
        @if (form.entityType$ | async; as entityType) {
          <oiq-form-search
            label="Search"
            formControlName="entityId"
            [store]="entitySearchStore"
            class="block"
            (event)="handleSearchEvent($event)"
            [configuration]="{ id: 'id', text: 'name' }">
          </oiq-form-search>

          <div>
            <span class="text-capitalize me-2">Entity link:</span>
            @if (form.entityLink$ | async; as _link) {
              <a class="text-primary" [routerLink]="_link" (click)="closeDialog(true)">{{
                form.value.entityName
              }}</a>
            }
          </div>
        }
      </div>
    </div>
  }

  <oiq-form-input formControlName="title" label="Title" class="col-span-4"></oiq-form-input>

  <oiq-form-text
    formControlName="description"
    label="Enter notes"
    textRows="6"
    class="col-span-4"></oiq-form-text>
</form>
